import React from "react";
import { Box } from "./style";
import Textarea from "react-textarea-autosize";

export default props => {
  const formStatus = () => {
    if (props.meta) {
      if (props.meta.error) {
        return "error";
      }
    }
  };
  const notice = () => {
    if (props.meta.error) {
      return <span className="notice">{props.meta.error}</span>;
    }
  };  
  return (
    <Box status={formStatus()} padding={props.padding}>
      <Textarea
        minRows={props.minRows || 1}
        maxLength={props.maxLength}
        maxRows={props.maxRows || 5}
        onChange={e => props.input.onChange(e.target.value)}
        value={props.input.value}
        placeholder={props.placeholder}
      />
      {notice()}
    </Box>
  );
};
